const STOCK_PHOTO_ASSETS_PATH_PREFIX = '/m/';
const firstSlashRgx = /^\/+/;
const stockPhotoAssetsPathPrefixRgx = /^m2?\//;

export function getStockPhotoUrlForEdmundsAssets(url) {
  if (!url) {
    return url;
  }

  const urlWithoutLeadingSlash = url.replace(firstSlashRgx, '');
  const urlWithoutStockPhotoAssetsPathPrefix = urlWithoutLeadingSlash.replace(stockPhotoAssetsPathPrefixRgx, '');

  return `${STOCK_PHOTO_ASSETS_PATH_PREFIX}${urlWithoutStockPhotoAssetsPathPrefix}`;
}
